import Button from 'components/Button';
import tw, { styled } from 'twin.macro';

export const SavePanel = tw.div`
first-letter:capitalize relative flex flex-col justify-center items-center gap-4
bg-[#F9FCFD] rounded-3xl   px-16 py-[4.5rem]
`;
export const CloseButton = styled(Button)`
  ${tw`absolute -top-4 -right-4`}
`;

export const ErrorMessage = tw.p`
   text-red-500 text-base font-medium capitalize
`;

export const BtnsWrapper = tw.div`
  w-full flex justify-center items-center gap-2
`;
